import { load } from '@/util/router-utils.js'

export default [
  {
    path: 'reports',
    redirect: 'reports/mixer-loads'
  },
  {
    path: 'reports/kkz',
    components: {
      default: load('app/client/farm/reports/kkz/ReportsHeader'),
      full: load('app/client/farm/reports/kkz/Index')
    }
  },
  {
    path: 'reports/mixer-loads',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/mixer-loads/MixerLoads')
    }
  },
  {
    path: 'reports/mixer-loads/:id/detail',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/mixer-loads/MixerLoads')
    }
  },
  {
    path: 'reports/mixer-uploads',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/mixer-uploads/MixerUploads')
    }
  },
  {
    path: 'reports/mixer-uploads/:id/detail',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/mixer-uploads/MixerUploads')
    }
  },
  {
    path: 'reports/planfeed',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/planfeed/Planfeed')
    }
  },
  {
    path: 'reports/planfeed/:id/detail',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/planfeed/Planfeed')
    }
  },
  {
    path: 'reports/inout',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/inout/Inout')
    }
  },
  {
    path: 'reports/consumption',
    components: {
      default: load('app/client/farm/reports/FarmReports'),
      full: load('app/client/farm/reports/consumption/Consumption')
    }
  }
]
